import { useState } from 'react';
import { Link } from 'react-router-dom';

export default function HomePage() {
  const [expandedCard, setExpandedCard] = useState(0);

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const coreValues = [
    {
      title: '#주도적 문화예술교육',
      description: '스스로 생각하고 주도하는 문화예술교육을 통해 사고합니다',
      image: 'https://static.readdy.ai/image/de054b09e62666f665ae5bcac91b699b/fad2018cea455d10854a7e6185cdbfed.jpeg'
    },
    {
      title: '#탐구',
      description: '깊이 있는 사고를 통해 예술의 본질을 탐구합니다',
      image: 'https://static.readdy.ai/image/de054b09e62666f665ae5bcac91b699b/9ceb521514744e4a9ba02808a2a51b10.jpeg'
    },
    {
      title: '#다양성',
      description: '다양한 관점과 표현을 존중하며 포용합니다',
      image: 'https://static.readdy.ai/image/de054b09e62666f665ae5bcac91b699b/a1c2f7e271de7d2ebb3f227242b57cbe.jpeg'
    },
    {
      title: '#미래',
      description: '실험적 활동으로 새로운 가능성을 검토하며 성장합니다',
      image: 'https://static.readdy.ai/image/de054b09e62666f665ae5bcac91b699b/7e75555ee8e43b90d300fb51ff337aab.jpeg'
    },
    {
      title: '탐구',
      description: '내면의 목소리를 발견하고 자신만의 예술세계를 구축합니다',
      image: 'https://static.readdy.ai/image/de054b09e62666f665ae5bcac91b699b/177c9382c75dbcca7617188f28321d8d.jpeg'
    }
  ];

  const planningDirections = [
    {
      title: '생각하는 문화예술교육',
      description: '다양한 기술을 넘어 예술을 통해 사고하는 방법을 배웁니다. 질문하고 느끼며 자신의 답을 찾아가는 과정을 소중하게 여깁니다.',
      category: '교육 철학',
      detail: '창의적 사고력 향상'
    },
    {
      title: '용기있는 문화예술교육',
      description: '두려움 없이 자신의 생각을 예술로 표현하는 용기를 응원합니다.',
      category: '표현 방법',
      detail: '예술활동'
    },
    {
      title: '인정하는 문화예술교육',
      description: '각자의 성격과 다양한 입장을 나타내며, 서로 다른 배경과 환경을 작업으로 연결합니다. 다름을 인정하고 함께 성장합니다.',
      category: '가치 지향',
      detail: '포용적 예술 환경'
    },
    {
      title: '활동적인 문화예술교육',
      description: '수동적인 자아가 아니라 활동적인 참여자로서 문화예술을 주도하는 참여자를 양성합니다. 지역사회의 문화발전에 기여하는 리더로 성장합니다.',
      category: '시민 교육',
      detail: '능동적 문화 참여'
    },
    {
      title: '상상하는 예술의 장',
      description: '가치 있는 공간을 열 수 있습니다.',
      category: '같이와 가치',
      detail: '모두를 위한 예술'
    }
  ];

  const participationMethods = [
    {
      title: '워크샵 참여',
      category: '교육 프로그램',
      image: 'https://static.readdy.ai/image/de054b09e62666f665ae5bcac91b699b/b22b3dd58e073786c87ae1ef15899bf1.jpeg'
    },
    {
      title: '함께나누다',
      category: '협력',
      image: 'https://static.readdy.ai/image/de054b09e62666f665ae5bcac91b699b/2ae9be34b3d2ee9c00bef72eb6e19ea4.jpeg'
    },
    {
      title: '즐기다',
      category: '문화행사',
      image: 'https://static.readdy.ai/image/de054b09e62666f665ae5bcac91b699b/5194551a83e7e26f2731904d94683dd8.jpeg'
    }
  ];

  return (
    <div className="min-h-screen bg-white">
      {/* Navigation */}
      <nav className="fixed top-0 left-0 right-0 z-50 transition-all duration-300" id="navbar">
        <div className="container mx-auto px-6 py-5 flex items-center justify-between">
          <div className="flex items-center gap-3">
            <img src="https://public.readdy.ai/ai/img_res/d24e277a-1340-406d-83ed-2c335d7964ce.png" alt="ATPS Logo" className="h-12 w-auto object-contain" />
            <span className="text-xl font-bold text-white">ATPS</span>
          </div>
          <div className="flex items-center gap-8">
            <button onClick={() => scrollToSection('about')} className="text-sm font-medium text-white hover:text-teal-400 transition-colors whitespace-nowrap">소개</button>
            <button onClick={() => scrollToSection('overview')} className="text-sm font-medium text-white hover:text-teal-400 transition-colors whitespace-nowrap">프로젝트 개요</button>
            <button onClick={() => scrollToSection('core')} className="text-sm font-medium text-white hover:text-teal-400 transition-colors whitespace-nowrap">핵심 요소</button>
            <button onClick={() => scrollToSection('planning')} className="text-sm font-medium text-white hover:text-teal-400 transition-colors whitespace-nowrap">기획 방향</button>
            <button onClick={() => scrollToSection('participation')} className="text-sm font-medium text-white hover:text-teal-400 transition-colors whitespace-nowrap">참여 방법</button>
            <button onClick={() => scrollToSection('contact')} className="text-sm font-medium text-white hover:text-teal-400 transition-colors whitespace-nowrap">연락처</button>
          </div>
        </div>
      </nav>

      {/* Hero Section */}
      <section className="relative min-h-screen flex items-center overflow-hidden pt-24">
        <img 
          src="https://static.readdy.ai/image/de054b09e62666f665ae5bcac91b699b/aa8a211e0ba53d4c7f5f5c168e1ecfe6.jpeg" 
          alt="Hero Background" 
          className="absolute inset-0 w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/40"></div>
        
        <div className="relative z-10 container mx-auto px-6 w-full">
          <div className="flex flex-col items-start justify-center min-h-[calc(100vh-6rem)]">
            <div className="max-w-3xl">
              <h1 className="text-7xl font-bold text-white mb-6 leading-tight">
                함께하는 것이<br />
                <span className="font-light italic">문화예술교육이다</span>
              </h1>
              
              <p className="text-white text-lg leading-relaxed mb-8">
                예술활동가의 컨텐츠 개발부터<br />
                지역사회 커뮤니티 구성까지
              </p>
              
              <button 
                onClick={() => scrollToSection('overview')}
                className="inline-flex items-center gap-3 bg-white text-gray-900 px-8 py-4 rounded-full font-medium hover:bg-teal-500 hover:text-white transition-all duration-300 whitespace-nowrap cursor-pointer"
              >
                프로젝트 알아보기
                <i className="ri-arrow-right-line text-xl"></i>
              </button>
            </div>
          </div>
        </div>
      </section>

      {/* About Section */}
      <section id="about" className="py-32 bg-white">
        <div className="container mx-auto px-6">
          <div className="text-center max-w-5xl mx-auto">
            <div className="inline-flex items-center gap-2 border border-gray-300 rounded-full px-6 py-2 mb-12">
              <span className="text-sm font-medium text-gray-700 tracking-wider">ABOUT ATPS</span>
            </div>
            
            <h2 className="text-6xl font-light text-gray-900 leading-tight mb-4">
              문화예술교육으로 
              <span className="inline-flex items-center mx-3">
                <i className="ri-brush-line text-5xl text-teal-500"></i>
              </span>
              <br />
              지역사회와 함께 
              <span className="inline-flex items-center mx-3">
                <i className="ri-team-line text-5xl text-teal-500"></i>
              </span>
              <br />
              미래를 만듭니다 
              <span className="inline-flex items-center mx-3">
                <i className="ri-star-line text-5xl text-teal-500"></i>
              </span>
            </h2>
          </div>
        </div>
      </section>

      {/* Project Overview Section */}
      <section id="overview" className="py-32 bg-gray-50">
        <div className="container mx-auto px-6">
          <div className="max-w-5xl mx-auto">
            <h2 className="text-5xl font-bold text-gray-900 mb-12 text-center">프로젝트 개요</h2>
            <div className="text-xl text-gray-600 leading-relaxed mb-16 text-center max-w-4xl mx-auto space-y-4">
              <p>ATPS(Art Technology People Society) 프로젝트는 2012년 시작으로</p>
              <p>현재 문화예술교육 전문가의 컨텐츠 개발, 실행과</p>
              <p>지역 문화예술교육에 기여함을 목적으로 운영되고 있습니다.</p>
            </div>
            
            <div className="grid grid-cols-3 gap-8">
              <div className="bg-white p-10 rounded-2xl shadow-sm hover:shadow-lg transition-all duration-300">
                <div className="w-16 h-16 bg-teal-100 rounded-full flex items-center justify-center mx-auto mb-6">
                  <i className="ri-lightbulb-flash-line text-3xl text-teal-600"></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-4 text-center">컨텐츠 개발</h3>
                <p className="text-sm text-gray-600 leading-relaxed text-center">
                  예술교육 전문가의 혁신적인<br />
                  컨텐츠를 개발합니다
                </p>
              </div>
              
              <div className="bg-white p-10 rounded-2xl shadow-sm hover:shadow-lg transition-all duration-300">
                <div className="w-16 h-16 bg-teal-100 rounded-full flex items-center justify-center mx-auto mb-6">
                  <i className="ri-community-line text-3xl text-teal-600"></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-4 text-center">지역사회 커뮤니티</h3>
                <p className="text-sm text-gray-600 leading-relaxed text-center">
                  지역사회의 문화예술교육<br />
                  발전과 문화향유에 기여합니다
                </p>
              </div>
              
              <div className="bg-white p-10 rounded-2xl shadow-sm hover:shadow-lg transition-all duration-300">
                <div className="w-16 h-16 bg-teal-100 rounded-full flex items-center justify-center mx-auto mb-6">
                  <i className="ri-rocket-line text-3xl text-teal-600"></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-4 text-center">사업 추진</h3>
                <p className="text-sm text-gray-600 leading-relaxed text-center">
                  전문적인 문화예술활동사업을<br />
                  기획하고 실행합니다
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Core Values Section */}
      <section id="core" className="py-32 bg-gray-900">
        <div className="container mx-auto px-6">
          <h2 className="text-5xl font-bold text-white mb-16 text-center">ATPS의 핵심 가치 🎨</h2>
          
          <div className="flex gap-6">
            {coreValues.map((value, index) => (
              <div
                key={index}
                className={`relative rounded-3xl overflow-hidden cursor-pointer transition-all duration-500 ${
                  expandedCard === index ? 'flex-[2]' : 'flex-1'
                }`}
                style={{ height: '600px' }}
                onMouseEnter={() => setExpandedCard(index)}
              >
                <img 
                  src={value.image} 
                  alt={value.title}
                  className="absolute inset-0 w-full h-full object-cover object-top"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/40 to-transparent"></div>
                
                <div className="absolute bottom-0 left-0 right-0 p-8">
                  <h3 className="text-3xl font-bold text-white mb-3">{value.title}</h3>
                  <p className={`text-white text-sm leading-relaxed transition-all duration-500 ${
                    expandedCard === index ? 'opacity-100 max-h-32' : 'opacity-0 max-h-0'
                  }`}>
                    {value.description}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Planning Direction Section */}
      <section id="planning" className="py-32 bg-amber-50">
        <div className="container mx-auto px-6">
          <div className="mb-16 text-center">
            <div className="flex items-center gap-2 mb-4 justify-center">
              <div className="w-2 h-2 rounded-full bg-teal-500"></div>
              <span className="text-xs font-medium text-gray-600 tracking-wider uppercase">PLANNING DIRECTION</span>
            </div>
            <h2 className="text-6xl font-bold text-gray-900 mb-4 leading-tight">
              우리의 기획 방향
            </h2>
            <p className="text-lg text-gray-500 font-light">예술활동의 새로운 패러다임을 제시합니다</p>
          </div>
          
          <div className="grid grid-cols-3 gap-8 max-w-7xl mx-auto">
            {planningDirections.map((direction, index) => (
              <div key={index} className="bg-white rounded-2xl p-8 hover:shadow-xl transition-all duration-300 hover:-translate-y-1">
                <div className="flex gap-1 mb-6">
                  {[...Array(5)].map((_, i) => (
                    <i key={i} className="ri-star-fill text-orange-400 text-lg"></i>
                  ))}
                </div>
                
                <h3 className="text-xl font-bold text-gray-900 mb-4 min-h-[56px]">{direction.title}</h3>
                <p className="text-sm text-gray-600 leading-relaxed mb-6 min-h-[80px]">{direction.description}</p>
                
                <div className="flex items-center gap-3">
                  <div className="w-12 h-12 rounded-full bg-teal-100 flex items-center justify-center">
                    <i className="ri-palette-line text-xl text-teal-600"></i>
                  </div>
                  <div>
                    <div className="text-sm font-bold text-gray-900">{direction.category}</div>
                    <div className="text-xs text-gray-500">{direction.detail}</div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Participation Methods Section */}
      <section id="participation" className="py-32 bg-white">
        <div className="container mx-auto px-6">
          <div className="max-w-7xl mx-auto">
            <div className="flex items-start justify-between mb-16">
              <div>
                <h2 className="text-5xl font-bold text-gray-300 mb-2">상상이상</h2>
                <h2 className="text-6xl font-light italic text-gray-900">예술활동</h2>
              </div>
              
              <div className="max-w-xl">
                <p className="text-lg text-gray-700 leading-relaxed">
                  다양한 예술장르의 문화예술교육을 경험해보세요.<br />
                  무용, 연극, 뮤지컬 등 풍부한 프로그램을 제공합니다.
                </p>
              </div>
            </div>
            
            <div className="grid grid-cols-3 gap-8">
              {participationMethods.map((method, index) => (
                <div key={index} className="group cursor-pointer">
                  <div className="rounded-3xl overflow-hidden mb-6 h-80">
                    <img 
                      src={method.image} 
                      alt={method.title}
                      className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                    />
                  </div>
                  
                  <div className="inline-block bg-lime-100 text-gray-900 text-xs font-medium px-4 py-2 rounded-full mb-4">
                    {method.category}
                  </div>
                  
                  <h3 className="text-2xl font-bold text-gray-900">{method.title}</h3>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-32 bg-white">
        <div className="container mx-auto px-6">
          <div className="text-center max-w-3xl mx-auto">
            <h2 className="text-7xl font-bold text-gray-900 mb-6 tracking-wide uppercase">함께 시작해요</h2>
            <p className="text-2xl text-gray-700 mb-12 leading-relaxed">
              문화예술교육으로 주도하는 삶
            </p>
            
            <button 
              onClick={() => scrollToSection('contact')}
              className="inline-flex items-center gap-4 bg-black text-white px-8 py-5 rounded-full hover:bg-teal-600 transition-all duration-300 whitespace-nowrap"
            >
              <div className="w-10 h-10 rounded-full bg-orange-500 flex items-center justify-center">
                <i className="ri-mail-line text-white text-lg"></i>
              </div>
              <span className="font-medium text-lg">문의하기</span>
              <i className="ri-arrow-right-up-line text-2xl"></i>
            </button>
          </div>
        </div>
      </section>

      {/* Contact Section */}
      <section id="contact" className="py-32 bg-black text-white">
        <div className="container mx-auto px-6">
          <div className="grid grid-cols-3 gap-16 mb-16">
            <div>
              <h2 className="text-6xl font-bold mb-8">ATPS</h2>
              <p className="text-gray-400 leading-relaxed mb-8">
                2012년부터 현재까지 문화예술교육의 가치를 찾아가며,<br />
                지역사회와 함께 행복한 미래를 만들어갑니다.
              </p>
              
              <div className="flex gap-4">
                <a href="#" className="w-12 h-12 rounded-full border border-white/30 flex items-center justify-center hover:bg-white hover:text-black transition-all">
                  <i className="ri-facebook-fill text-xl"></i>
                </a>
                <a href="#" className="w-12 h-12 rounded-full border border-white/30 flex items-center justify-center hover:bg-white hover:text-black transition-all">
                  <i className="ri-instagram-line text-xl"></i>
                </a>
                <a href="#" className="w-12 h-12 rounded-full border border-white/30 flex items-center justify-center hover:bg-white hover:text-black transition-all">
                  <i className="ri-youtube-line text-xl"></i>
                </a>
                <a href="#" className="w-12 h-12 rounded-full border border-white/30 flex items-center justify-center hover:bg-white hover:text-black transition-all">
                  <i className="ri-twitter-x-line text-xl"></i>
                </a>
              </div>
            </div>
            
            <div className="space-y-8">
              <div>
                <div className="text-xs font-medium text-gray-500 mb-2 tracking-wider uppercase">ADDRESS</div>
                <div className="text-white">대구광역시 동구 용계로878-56</div>
                <div className="text-white">ATPS 프로젝트</div>
              </div>
              
              <div>
                <div className="text-xs font-medium text-gray-500 mb-2 tracking-wider uppercase">PHONE</div>
                <div className="text-white">010-4517-8770</div>
              </div>
              
              <div>
                <div className="text-xs font-medium text-gray-500 mb-2 tracking-wider uppercase">EMAIL</div>
                <div className="text-white">kwon756@hanmail.net</div>
              </div>
            </div>
          </div>
          
          <div className="border-t border-white/10 pt-8 flex items-center justify-between">
            <div className="text-sm text-gray-500">© 2024 ATPS. All rights reserved.</div>
            <div className="flex gap-8">
              <button onClick={() => scrollToSection('about')} className="text-sm text-gray-400 hover:text-white transition-colors whitespace-nowrap">소개</button>
              <button onClick={() => scrollToSection('planning')} className="text-sm text-gray-400 hover:text-white transition-colors whitespace-nowrap">기획 방향</button>
              <a href="https://readdy.ai/?ref=logo" target="_blank" rel="noopener noreferrer" className="text-sm text-gray-400 hover:text-white transition-colors whitespace-nowrap">Powered by Readdy</a>
            </div>
          </div>
        </div>
      </section>

      <style>{`
        #navbar {
          background: transparent;
        }
        
        #navbar.scrolled {
          background: white;
          box-shadow: 0 2px 10px rgba(0,0,0,0.1);
        }
        
        #navbar.scrolled button,
        #navbar.scrolled span {
          color: #111827 !important;
        }
        
        #navbar.scrolled button:hover {
          color: #14B8A6 !important;
        }
      `}</style>

      <script dangerouslySetInnerHTML={{
        __html: `
          window.addEventListener('scroll', function() {
            const navbar = document.getElementById('navbar');
            if (window.scrollY > 100) {
              navbar.classList.add('scrolled');
            } else {
              navbar.classList.remove('scrolled');
            }
          });
        `
      }} />
    </div>
  );
}
